import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="customer-filter" — constrains the Customer
// combobox to only the customers created by the chosen freelancer,
// disabling it until a freelancer is picked. Mirrors the mockup's Customer
// combobox (disabled/scoped by "Who did you work for?").
//
// #filter is triggered both by the freelancer's own change (see
// hidden_data on that combobox_field) and by "combobox:connect" bubbling up
// from any combobox in this scope (see the wrapping element's data-action)
// — the latter covers the initial page load, since Stimulus doesn't
// guarantee this controller's own connect() runs after the Customer
// combobox's.
export default class extends Controller {
  static targets = ["freelancerHidden", "customerCombobox"]

  filter() {
    const freelancerId = this.freelancerHiddenTarget.value
    const combobox = this.application.getControllerForElementAndIdentifier(this.customerComboboxTarget, "combobox")
    if (!combobox) return

    combobox.setConstraint("freelancerId", freelancerId, freelancerId === "")
  }
}
